import React from 'react';
import PropTypes from 'prop-types';
import styled from '../utils/styled';
import { withStyles } from '@material-ui/core/styles';
import {TextField, Typography, RaisedButton, Button, Grid} from '@material-ui/core';
import Markdown from 'react-markdown';

const Caption = styled(Typography, { variant: 'caption' })(theme => ({
  display: 'block',
  lineHeight: '80px',
  [theme.breakpoints.down('sm')]: {
    lineHeight: '40px',
  },
}));

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    //width: 200,
  },
});

function ContactForm(props) {
  const { classes } = props;
  const data = props.data;

  return (
    <div>
        <Typography variant="headline" component="h3">
          Kirjuta meile:
        </Typography>
        <form
            action="https://formspree.io/seiklus@seikluseksperdid.ee" 
            method="POST">
            
            <Grid container>
            
            <Grid item item xs={3}>
                  <TextField
                      id="name"
                      name="name"
                      label="Nimi"
                      className={classes.textField}
                      margin="normal"
                    />
            </Grid>
            <Grid item item xs={3}></Grid>
            <Grid item item xs={3}></Grid>
            <Grid item item xs={3}></Grid>
            
            <Grid item item xs={3}>
                <TextField
                    id="email"
                    type="email"
                    name="_replyto"
                    label="E-post"
                    className={classes.textField}
                    margin="normal"
                  />
          </Grid>
          <Grid item item xs={3}></Grid>
          <Grid item item xs={3}></Grid>
          <Grid item item xs={3}></Grid>
          
          <Grid item item xs={6}>
             <TextField
                 multiline
                 fullWidth
                 rows="4"
                 id="text"
                 name="text"
                 label="Sõnum"
                 className={classes.textField}
                 margin="normal"
                 InputProps={{ fullWidth: true }}/>
         </Grid>
        <Grid item item xs={12}>
        <input type="hidden" name="_next" value="https://www.seikluseksperdid.ee/contactsent" />
          <Button type='submit'>Saada</Button>
       </Grid>
     </Grid> 
     </form>
    </div>
  );
}

ContactForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm.js